export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '77420de9-552d-4173-bdfc-305865f28d8e',
      authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
      redirectUri: 'https://euwdtaxtc2wap01.azurewebsites.net',
    },
  },
  graphConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiConfig: {
    baseUrl: 'https://euwdtaxtc2wap02.azurewebsites.net/api',
    scopes: ['api://77420de9-552d-4173-bdfc-305865f28d8e/.default'],
  },
  fileUpload: {
    documentFileMaxSize: 10 * 1024 * 1024,
    requestProcessorFileMaxSize: 5 * 1024 * 1024,
  },
};
